export const ApprovalActionsEnum = {
    PENDING: {
        key: 500,
        value: 'pending',
    },
    APPROVED: {
        key: 502,
        value: 'approved',
    },
    REJECTED: {
        key: 503,
        value: 'rejected',
    },
    DELEGATED: {
        key: 504,
        value: 'delegated',
    },
    AUTO_APPROVED: {
        key: 505,
        value: 'auto-approved',
    },
    AUTO_DELEGATED: {
        key: 506,
        value: 'auto-delegated',
    },
    VIEWRESUME: {
        key: 507,
        value: 'view-resume',
    },
    CANCELLED: {
        key: 508,
        value: 'cancelled',
    },
};
